const FAQ_LINK = 'https://support.fabfitfun.com/en/articles/29-what-is-the-swap-for-credit-program';
const CONTACT_US_SWAP = 'https://support.fabfitfun.com/';
const CONTACT_US_WELCOME = 'https://support.fabfitfun.com/';
const CUSTOM_CARE_URL =
  'https://support.fabfitfun.com/en/articles/44-how-can-i-contact-customer-care';

export { FAQ_LINK, CONTACT_US_SWAP, CONTACT_US_WELCOME, CUSTOM_CARE_URL };
